export default __webpack_public_path__ + "static/joko-app-screenshot-home-4-fr@2x-727824282f0e2df93d86aa7dc05880b0.png";